/**
 * Format an entity reference using the short_code if available,
 * falling back to truncated UUID for backward compatibility.
 */
export function formatEntityRef(
  shortCode: string | null | undefined,
  uuid: string
): string {
  return shortCode ?? uuid.substring(0, 8).toUpperCase();
}

/**
 * Same as formatEntityRef but prefixed with #.
 */
export function formatEntityRefWithHash(
  shortCode: string | null | undefined,
  uuid: string
): string {
  return `#${formatEntityRef(shortCode, uuid)}`;
}
